function receiveMessage(event) {
    console.log(event.data);
    if (event.data === "t") {
        document.getElementById("display").style.display = "none";
        document.getElementById("display2").style.display = "none";
        document.getElementById("display3").style.display = "none";
        document.getElementById("display4").style.display = "none";
    } else {
        document.getElementById("display").style.display = "block";
        document.getElementById("display2").style.display = "block";
        document.getElementById("display3").style.display = "block";
        document.getElementById("display4").style.display = "block";
    }
}
window.addEventListener('message', receiveMessage, false);
console.log('listener added');